import { useCallback, useEffect, useState } from 'react';
/**
 * Reports whether a screenshot shortcut is held: PrintScreen, or Meta+Shift
 * (the macOS screenshot chord). Resets to false on the next keyup, so callers
 * can hide transient UI from captures.
 */
export const useOnPrintScreen = () => {
    const [isScreenshotting, setIsScreenshotting] = useState(false);
    const handleKeyDown = useCallback((e) => {
        if (e.key === 'PrintScreen' || (e.metaKey && e.shiftKey)) {
            setIsScreenshotting(true);
        }
    }, []);
    const handleKeyUp = useCallback(() => {
        setIsScreenshotting(false);
    }, []);
    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, [handleKeyDown, handleKeyUp]);
    return isScreenshotting;
};
//# sourceMappingURL=useOnPrintScreen.js.map